import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    minValue,
    NumberInput,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';

import { Ecom_Categories } from '../../custom';
import FileUpload from '../../common/inputs/FileUpload';
import { EditToolbar } from '../../common/EditToolbar';
import { STATUSES } from '../../common/constants';
import SlugInput from '../../common/inputs/SlugInput';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { createCustomGoDataProvider } from '../../services';

const CategoryEdit = () => {
    const { id } = useParams();
    const baseDataProvider = useDataProvider();

    if (!id) {
        return <LoadingSection />;
    }

    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_categories', apiEndpoint: `/ecom/categories` },
            ]),
        [baseDataProvider],
    );

    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Edit
                mutationMode={'pessimistic'}
                title={<CategoryTitle />}
                redirect="/ecom_categories"
                resource="ecom_categories"
                id={id}
            >
                <SimpleForm toolbar={<EditToolbar />}>
                    <FileUpload type="VIDEO_THUMBNAIL" source="image" accept={'image/*'} />
                    <TextInput source="name" fullWidth validate={[required()]} />
                    <SlugInput source="slug" fullWidth />
                    <NumberInput
                        type={'number'}
                        source="displayOrder"
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <SelectInput
                        source="status"
                        label={'Status'}
                        fullWidth
                        validate={[required()]}
                        choices={STATUSES}
                    />
                </SimpleForm>
            </Edit>
        </DataProviderContext.Provider>
    );
};

const CategoryTitle = () => {
    const record = useRecordContext<Ecom_Categories>();
    return record ? <span>{record.name}</span> : null;
};

export default CategoryEdit;
